<template>
    <div>
      <p class="ArticleNormal">
        当区域的发展进入活力期，与之对应的城市营销迎来了机遇的爆发阶段。特色各异的城市给品牌营销以多层次、多维度的切入方式与创新玩法，也提出了新的问题与挑战。这要求我们聚焦区域发展，对城市营销进行系统性思考。作为领先的数字化营销服务平台，巨量引擎希望能以同行者的身份，为行业、平台方提供共赢对话的平台，同时也发挥自身的技术和平台实践优势，去引领行业视角。
      </p>
      <p class="ArticleNormal">
        此前，巨量引擎已经打造了为营销行业提供前瞻性思考和实践性洞察的平台—「动见」。在这基础上，我们又打造了一个面向本地客户的子品牌「域见中国」，以此探索区域发展与城市营销耦合过程中的机遇与挑战，连接产业链路上的关键角色，助力城市品牌主洞察潮水方向、前瞻未来趋势。
      </p>
      <p class="ArticleNormal">
        在第一期，我们基于与中国城市规划设计研究院合作的《美好城市指数白皮书》内容，联动清华大学国家形象传播研究中心，共同探讨“短视频与城市繁荣”的问题。为了更立体地展现城市传播的营销思路，我们邀请到了城市形象传播的政府操盘手、行业KOL、专家学者、机构等组成智囊团，力求输出系统化、专业化的思路，为城市营销的实践带来更多的灵感与启发。
      </p>
      <p class="ArticleNormal">
        而在未来，我们还将继续挖掘区域发展、城市营销相关主题，扮演好连接者、引路者、同行者的角色。也欢迎所有朋友们与我们一起思考、一起行动，激发生意新可能。
      </p>
    </div>
</template>

<script>
    export default {
        name: "Article0"
    }
</script>

<style scoped>
  img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/Articles/Article0.vue